import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-01c1e2f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile cart" }
const _hoisted_2 = { class: "card profile-info full-height" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Избранное", -1))
const _hoisted_5 = { class: "products-container mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "product-list row gx-4 gy-4"
}
const _hoisted_7 = {
  key: 1,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.products?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, index) => {
                  return (_openBlock(), _createBlock(_component_ProductCard, {
                    class: "col-md-4",
                    key: index,
                    product: item.product
                  }, null, 8, ["product"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, "Список избранных пуст"))
        ])
      ])
    ])
  ]))
}